const NON_PARAMETER_TOKENS = new Set(['BySystemName', 'BySystemTypeName']);

const NATIVE_REVIT_CONNECTOR_PARAMETERS = new Set([
  'insulation type',
  'insulation thickness',
]);

const PARAMETER_ALIASES: Record<string, string> = {
  PiX_PPG_INSULATION_TYPE: 'PiX_GN_2_InsulationSpec',
  PiX_PPG_INSULATION_THICKNESS: 'PiX_GN_2_InsulationThickness',
};

const PARAMETER_EQUIVALENCE_GROUPS = [
  ['PiX_PPG_INSULATION_TYPE', 'PiX_GN_2_InsulationSpec', 'Insulation Type'],
  [
    'PiX_PPG_INSULATION_THICKNESS',
    'PiX_GN_2_InsulationThickness',
    'Insulation Thickness',
    'INSULATIONTHICKNESS',
  ],
];

const PARAMETER_EQUIVALENCE_LOOKUP = new Map<string, string[]>();

PARAMETER_EQUIVALENCE_GROUPS.forEach((group) => {
  group.forEach((name) => {
    PARAMETER_EQUIVALENCE_LOOKUP.set(name.trim().toLowerCase(), group);
  });
});

export function normalizeRevitParameterName(name: string): string {
  return PARAMETER_ALIASES[name] ?? name;
}

export function getEquivalentRevitParameterNames(name: string): string[] {
  const trimmed = name.trim();
  if (!trimmed) {
    return [];
  }

  const equivalentNames = PARAMETER_EQUIVALENCE_LOOKUP.get(trimmed.toLowerCase()) ?? [];
  return Array.from(new Set([trimmed, ...equivalentNames]));
}

export function buildEquivalentRevitParameterNameLookup(names: string[]): Set<string> {
  return new Set(
    names.flatMap(getEquivalentRevitParameterNames).map((name) => name.toLowerCase())
  );
}

export function isNativeRevitConnectorParameterName(name: string): boolean {
  return NATIVE_REVIT_CONNECTOR_PARAMETERS.has(name.trim().toLowerCase());
}

export function sanitizeRevitParameterNames(names: Array<string | undefined | null>): string[] {
  const result = new Set<string>();

  names.forEach((rawName) => {
    if (!rawName) return;
    const trimmed = rawName.trim();
    if (!trimmed || NON_PARAMETER_TOKENS.has(trimmed)) return;
    result.add(trimmed);
  });

  return Array.from(result);
}
